export default __webpack_public_path__ + "static/media/third-right-img@2x.87d771c6.webp";